<template>
  <HomeLayout>
    <div v-if="loading">
      <ProgressPage />
    </div>
    <div v-if="!loading">
      <div class="Profile margin-at-mobile">
        <SoilExamination :farm="activeService" />
      </div>
    </div>
  </HomeLayout>
</template>

<script>
import HomeLayout from "../layout/HomeLayout";
import SoilExamination from "../components/SoilConsulting/SoilExamination.vue";
import {globalMixin} from "@/mixins/globalMixin";
import {mapMixin} from "@/mixins/mapMixin";
import Api from "@/common/api";
import ProgressPage from "../components/UI/ProgressPage.vue";

export default {
  name: "SoilTest",
  components: {
    HomeLayout,
    SoilExamination,
    ProgressPage
  },
  inject: ["$axios"],
  mixins: [globalMixin, mapMixin],
  data() {
    return {
      activeService: null,
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.homeData();
  },
  methods: {
    homeData() {
      let self = this;
      Api.getHomeApi({self: this})
          .then((response) => {
            if (response.status === 200) {
              let data = response.data;
              this.loading = false;
              this.activeService = data.latest_service;
            }
          })
          .catch((error) => {
            this.loading = false;
            self.handleError(self, error);
          });
    },
  }
}
</script>

<style lang="scss">
@import "src/styles/modules/Meteorology/Meteorology";
</style>